(() => {
  const root = document.querySelector('[data-bb-search-landing]');
  if (!root) return;

  const allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  const current = new URL(window.location.href);
  root.querySelectorAll('a[data-bb-search-cta]').forEach((link) => {
    const target = new URL(link.href, window.location.origin);
    allowedParams.forEach((key) => {
      const value = current.searchParams.get(key);
      if (value) target.searchParams.set(key, value);
    });
    link.href = target.toString();
  });

  root.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-bb-search-cta]');
    const customEvent = event.target.closest('[data-bb-search-event]');
    const eventName = cta ? 'bb_landing_cta_click' : customEvent ? `bb_${customEvent.dataset.bbSearchEvent}` : null;
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      placement: cta ? cta.dataset.bbSearchCta : customEvent.dataset.bbSearchEvent,
      landing_path: window.location.pathname,
    });
  });

  const sticky = root.querySelector('.bb-search__sticky');
  const plans = root.querySelector('#bb-search-plans');
  if (sticky && plans && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('is-hidden', entry.isIntersecting), { threshold: 0.05 }).observe(plans);
  }
})();
